import React from 'react';

export default function Clock(props) {
  const [state, setState] = React.useState(0);
  const [clockId, setClockId] = React.useState(null);

  const animateTick = () => {
    setState('off');
    const timer = setTimeout(() => {
      setState('on');
      clearTimeout(timer);
    }, props.period/2*1000);
  };

  const tick = () => {
    if (props.tick) props.tick();
    animateTick();
  };

  const resetClock = period => {
    if (clockId) { clearInterval(clockId); setClockId(null); }
    if (period > 0) setClockId(setInterval(() => tick(), period*1000));
  };

  React.useEffect(() => {
    resetClock(props.period);
    //return function cleanup() { resetClock(-1); };
  }, [props.period]);

  const { label } = props;
  const klass = state;
  return (
    <p>
      <strong>{label}</strong>:
      <span id="clock"className={klass}>&nbsp;</span>
    </p>
  );
}

/*

class Clock extends React.Component {
  constructor(props) {
    super(props);
    this.state = { state: 0 };
  }

  componentDidMount() {
    this.resetClock(this.props.period);
  }

  componentWillUnmount() {
    this.resetClock(-1);
  }

  componentDidUpdate(prevProps) {
    const { period } = this.props;
    if (prevProps.period !== period) this.resetClock(period);
  }

  tick() {
    if (this.props.tick) this.props.tick();
    this.animateTick();
  }

  resetClock(period) {
    if (this.state.clockId) clearInterval(this.state.clockId);
    if (period > 0) {
      const clockId = setInterval(() => this.tick(), period*1000);
      this.setState({clockId});
    }
  }

  animateTick() {
    this.setState({state: 0});
    const timer = setTimeout(() => {
      this.setState({state: 1});
      clearTimeout(timer);
    }, this.props.period/2*1000);
  }


  render() {
    const { label } = this.props;
    const klass = (this.state.state === 1) ? 'on' : 'off';
    return (
      <p>
        <strong>{label}</strong>:
        <span id="clock"className={klass}>&nbsp;</span>
      </p>
    );
  }

}

export default Clock;

*/
